import React, { useState } from 'react'
import { Grid, Typography, Box, Collapse } from '@mui/material'
import ArrowDropDown from '@mui/icons-material/ArrowDropDown'
import ArrowDropUp from '@mui/icons-material/ArrowDropUp'
import PreviousAssessmentContainer from './PreviousAssessmentContainer'


/** 
 * 
 * This component is expecting the following input. 
{
    "PreviousAssessmentsSQL": [
        {
            "AssmtGuid": "177264AB-0D91-4260-8EF4-868399A9058F",
            "Date": "2023-02-09",
            "HealthAge": "",
            "HealthAgeCaption": "Health Age",
            "Ows": "",
            "OwsCaption": "Overall Wellness Score",
            "PrViGuid": "EA1DEB23-B16D-4ADF-A5AA-8FA0DD96C164",
            "PsViGuid": "F4181D5E-031F-429B-91F4-5BC0DE780695",
            "EditAssessmentText": "Edit Assessment",
            "EditAssessmentVisible": "1",
            "GetExtDocText": "Personal Wellness Profile",
            "GetPersReptText": "Personal Report",
            "GetPhySummText": "Physician Summary",
            "ExtDocDate": "",
            "ExtDocGuid": "",
            "GetExtDocVisible": ""
        },
        {
            "AssmtGuid": "31D22426-AEF6-46EE-A04E-63A092488E7B",
            "Date": "2023-02-02",
            "HealthAge": "",
            "HealthAgeCaption": "Health Age",
            "Ows": "",
            "OwsCaption": "Overall Wellness Score",
            "PrViGuid": "EA1DEB23-B16D-4ADF-A5AA-8FA0DD96C164",
            "PsViGuid": "F4181D5E-031F-429B-91F4-5BC0DE780695",
            "EditAssessmentText": "Edit Assessment",
            "EditAssessmentVisible": "1",
            "GetExtDocText": "Personal Wellness Profile",
            "GetPersReptText": "Personal Report",
            "GetPhySummText": "Physician Summary",
            "ExtDocDate": "",
            "ExtDocGuid": "",
            "GetExtDocVisible": ""
        }
    ],
    "PreviousYearsText": "View Previous Years",
    "HidePreviousYearsText": "Hide Previous Years"
}
*/

const PreviousAssessments = (props) => {

    const PreviousAssessmentArray = props.PreviousAssessmentsFrame && props.PreviousAssessmentsFrame.PreviousAssessmentsSQL ? props.PreviousAssessmentsFrame.PreviousAssessmentsSQL : []
    const { HidePreviousYearsText, PreviousYearsText } = props.PreviousAssessmentsFrame

    const [hidePrevious, setHidePrevious] = useState(false)


    
    return (

        <>
        { ( PreviousAssessmentArray.length > 0 ) && 
            <Box mt={2}>

                <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                    <Grid item xs={12}>
                        <Box onClick={() => setHidePrevious(!hidePrevious)}>
                            <Typography variant="body1" align="center" fontWeight="bold">{hidePrevious ? PreviousYearsText : HidePreviousYearsText} {hidePrevious ? <ArrowDropUp /> : <ArrowDropDown />} </Typography>
                        </Box>
                    </Grid>


                    <Grid item xs={8}>
                        <Collapse in={!hidePrevious} timeout="auto" unmountOnExit>


                            <PreviousAssessmentContainer PreviousAssessments={PreviousAssessmentArray} />

                        </Collapse>
                    </Grid>


                </Grid >

            </Box>
        }
        </>
    )
}

export default PreviousAssessments